/**
 * Date formatting utilities
 * 
 * Centralized date formatting functions used across the application.
 */

/**
 * Format date for display in a readable format
 *
 * @param dateString - ISO date string
 * @returns Formatted date string (e.g., "Jan 15, 2025")
 */
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    // Backend sends calendar dates as UTC instants. Rendering them in the
    // viewer's zone shifts the day for anyone west of UTC.
    timeZone: 'UTC',
  });
};

/**
 * Format last login date for Financial Advisor dashboard
 * Feature 001: FA Dashboard Messaging & Referral Improvements
 *
 * @param lastLoginAt - ISO date string or null
 * @returns Formatted string (e.g., "1/9/2026") or "Never logged in"
 */
export const formatLastLogin = (lastLoginAt: string | null): string => {
  if (!lastLoginAt) {
    return 'Never logged in';
  }

  const date = new Date(lastLoginAt);

  // Check if date is valid
  if (isNaN(date.getTime())) {
    return 'Never logged in';
  }

  // Format as numeric: 1/9/2026
  return new Intl.DateTimeFormat('en-US', {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
};
